var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildWithAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 44.9918C34.9124 44.9918 44.982 34.9222 44.982 22.5008C44.982 10.0793 34.9124 0.00976562 22.491 0.00976562C10.0696 0.00976562 0 10.0793 0 22.5008C0 34.9222 10.0696 44.9918 22.491 44.9918Z",
    fill: "url(#paint0_linear_6171_452054)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6171_452054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 44.9918C34.9124 44.9918 44.982 34.9222 44.982 22.5008C44.982 10.0793 34.9124 0.00976562 22.491 0.00976562C10.0696 0.00976562 0 10.0793 0 22.5008C0 34.9222 10.0696 44.9918 22.491 44.9918Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6171_452054)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M24.0788 12.3711L44.9832 25.4869V44.9908L40.1419 34.4944L22.3047 14.4925L22.7055 13.1349L24.0788 12.3711Z",
    fill: "#006546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6171_452054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 44.9918C34.9124 44.9918 44.982 34.9222 44.982 22.5008C44.982 10.0793 34.9124 0.00976562 22.491 0.00976562C10.0696 0.00976562 0 10.0793 0 22.5008C0 34.9222 10.0696 44.9918 22.491 44.9918Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6171_452054)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.213 12.4941L44.0746 30.4966L40.6854 35.733L40.148 34.5004L22.0821 14.1988L22.213 12.4941Z",
    fill: "#C327D1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6171_452054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5105 44.9918C34.932 44.9918 45.0015 34.9222 45.0015 22.5008C45.0015 10.0793 34.932 0.00976562 22.5105 0.00976562C10.0891 0.00976562 0.0195312 10.0793 0.0195312 22.5008C0.0195312 34.9222 10.0891 44.9918 22.5105 44.9918Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6171_452054)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M21.8372 28.1191L36.3617 40.2848L30.4224 53.5804L25.5811 43.084L16.457 34.5372L17.8871 30.8346L21.8372 28.1191Z",
    fill: "#006546"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6171_452054",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 44.9918C34.9124 44.9918 44.982 34.9222 44.982 22.5008C44.982 10.0793 34.9124 0.00976562 22.491 0.00976562C10.0696 0.00976562 0 10.0793 0 22.5008C0 34.9222 10.0696 44.9918 22.491 44.9918Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6171_452054)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.4042 30.209L30.649 43.5566L26.3109 44.7089L25.5858 43.0908L16.5391 34.6215L17.4042 30.209Z",
    fill: "#C327D1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5415 28.0108C22.1099 28.0108 20.7369 27.4421 19.7246 26.4298C18.7123 25.4175 18.1436 24.0446 18.1436 22.613C18.1436 22.3744 18.0489 22.1456 17.8801 21.9768C17.7114 21.8081 17.4826 21.7134 17.244 21.7134C17.0054 21.7134 16.7766 21.8081 16.6079 21.9768C16.4391 22.1456 16.3444 22.3744 16.3444 22.613C16.3444 24.0446 15.7757 25.4175 14.7634 26.4298C13.7511 27.4421 12.3781 28.0108 10.9465 28.0108C10.7079 28.0108 10.4791 28.1056 10.3104 28.2743C10.1417 28.443 10.0469 28.6719 10.0469 28.9105C10.0469 29.1491 10.1417 29.3779 10.3104 29.5466C10.4791 29.7153 10.7079 29.8101 10.9465 29.8101C12.3781 29.8101 13.7511 30.3788 14.7634 31.3911C15.7757 32.4034 16.3444 33.7764 16.3444 35.208C16.3444 35.4465 16.4391 35.6754 16.6079 35.8441C16.7766 36.0128 17.0054 36.1076 17.244 36.1076C17.4826 36.1076 17.7114 36.0128 17.8801 35.8441C18.0489 35.6754 18.1436 35.4465 18.1436 35.208C18.1436 33.7764 18.7123 32.4034 19.7246 31.3911C20.7369 30.3788 22.1099 29.8101 23.5415 29.8101C23.7801 29.8101 24.0089 29.7153 24.1776 29.5466C24.3463 29.3779 24.4411 29.1491 24.4411 28.9105C24.4411 28.6719 24.3463 28.443 24.1776 28.2743C24.0089 28.1056 23.7801 28.0108 23.5415 28.0108Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1364 19.4642C35.0635 19.4619 34.0351 19.0346 33.2764 18.2759C32.5177 17.5172 32.0904 16.4888 32.0881 15.4159C32.0881 15.1773 31.9933 14.9484 31.8246 14.7797C31.6558 14.611 31.427 14.5162 31.1884 14.5162C30.9498 14.5162 30.721 14.611 30.5523 14.7797C30.3836 14.9484 30.2888 15.1773 30.2888 15.4159C30.2864 16.4888 29.8591 17.5172 29.1004 18.2759C28.3417 19.0346 27.3134 19.4619 26.2404 19.4642C26.0018 19.4642 25.773 19.559 25.6043 19.7277C25.4355 19.8965 25.3408 20.1253 25.3408 20.3639C25.3408 20.6025 25.4355 20.8313 25.6043 21C25.773 21.1687 26.0018 21.2635 26.2404 21.2635C27.3134 21.2659 28.3417 21.6932 29.1004 22.4519C29.8591 23.2106 30.2864 24.2389 30.2888 25.3119C30.2888 25.5505 30.3836 25.7793 30.5523 25.9481C30.721 26.1168 30.9498 26.2115 31.1884 26.2115C31.427 26.2115 31.6558 26.1168 31.8246 25.9481C31.9933 25.7793 32.0881 25.5505 32.0881 25.3119C32.0904 24.2389 32.5177 23.2106 33.2764 22.4519C34.0351 21.6932 35.0635 21.2659 36.1364 21.2635C36.375 21.2635 36.6039 21.1687 36.7726 21C36.9413 20.8313 37.0361 20.6025 37.0361 20.3639C37.0361 20.1253 36.9413 19.8965 36.7726 19.7277C36.6039 19.559 36.375 19.4642 36.1364 19.4642Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1436 13.6166C18.8594 13.6166 19.5459 13.9009 20.0521 14.4071C20.5582 14.9132 20.8426 15.5997 20.8426 16.3155C20.8426 16.5541 20.9373 16.7829 21.1061 16.9517C21.2748 17.1204 21.5036 17.2151 21.7422 17.2151C21.9808 17.2151 22.2096 17.1204 22.3783 16.9517C22.5471 16.7829 22.6418 16.5541 22.6418 16.3155C22.6418 15.5997 22.9262 14.9132 23.4323 14.4071C23.9385 13.9009 24.625 13.6166 25.3408 13.6166C25.5794 13.6166 25.8082 13.5218 25.9769 13.3531C26.1456 13.1844 26.2404 12.9555 26.2404 12.7169C26.2404 12.4784 26.1456 12.2495 25.9769 12.0808C25.8082 11.9121 25.5794 11.8173 25.3408 11.8173C24.625 11.8173 23.9385 11.533 23.4323 11.0268C22.9262 10.5207 22.6418 9.83419 22.6418 9.11839C22.6418 8.87979 22.5471 8.65096 22.3783 8.48225C22.2096 8.31353 21.9808 8.21875 21.7422 8.21875C21.5036 8.21875 21.2748 8.31353 21.1061 8.48225C20.9373 8.65096 20.8426 8.87979 20.8426 9.11839C20.8426 9.83419 20.5582 10.5207 20.0521 11.0268C19.5459 11.533 18.8594 11.8173 18.1436 11.8173C17.905 11.8173 17.6762 11.9121 17.5075 12.0808C17.3388 12.2495 17.244 12.4784 17.244 12.7169C17.244 12.9555 17.3388 13.1844 17.5075 13.3531C17.6762 13.5218 17.905 13.6166 18.1436 13.6166Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.14 36.1076C27.6369 36.1076 28.0397 35.7048 28.0397 35.208C28.0397 34.7111 27.6369 34.3083 27.14 34.3083C26.6432 34.3083 26.2404 34.7111 26.2404 35.208C26.2404 35.7048 26.6432 36.1076 27.14 36.1076Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6418 24.4123C23.1387 24.4123 23.5415 24.0095 23.5415 23.5126C23.5415 23.0158 23.1387 22.613 22.6418 22.613C22.145 22.613 21.7422 23.0158 21.7422 23.5126C21.7422 24.0095 22.145 24.4123 22.6418 24.4123Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8462 19.9141C12.343 19.9141 12.7458 19.5113 12.7458 19.0144C12.7458 18.5176 12.343 18.1148 11.8462 18.1148C11.3493 18.1148 10.9465 18.5176 10.9465 19.0144C10.9465 19.5113 11.3493 19.9141 11.8462 19.9141Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 13.6166C33.9344 13.6166 34.3372 13.2138 34.3372 12.7169C34.3372 12.2201 33.9344 11.8173 33.4375 11.8173C32.9407 11.8173 32.5379 12.2201 32.5379 12.7169C32.5379 13.2138 32.9407 13.6166 33.4375 13.6166Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.535 31.34C35.0319 31.34 35.4347 30.9372 35.4347 30.4403C35.4347 29.9435 35.0319 29.5407 34.535 29.5407C34.0382 29.5407 33.6354 29.9435 33.6354 30.4403C33.6354 30.9372 34.0382 31.34 34.535 31.34Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6171_452054",
    x1: 22.491,
    y1: 0.00976562,
    x2: 22.491,
    y2: 44.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildWithAi);
export default __webpack_public_path__ + "static/media/build_with_ai.38863f398e06f265efe2fb6b740fa7d0.svg";
export { ForwardRef as ReactComponent };